import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="relative py-16 md:py-24 bg-background-50 overflow-hidden">
      {/* 装饰光晕 */}
      <div className="absolute top-1/2 left-0 w-[500px] h-[500px] rounded-full bg-primary-100/20 blur-[120px] pointer-events-none -translate-y-1/2" />
      <div className="absolute bottom-0 right-1/4 w-[350px] h-[350px] rounded-full bg-accent-100/25 blur-[100px] pointer-events-none" />

      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-start">
          <div className="lg:w-2/5">
            <span className="inline-block px-3 py-1 rounded-full border border-foreground-200 text-xs font-medium text-foreground-500 whitespace-nowrap bg-background-50/80">
              What is Pandabuy Sheet?
            </span>
            <h2 className="mt-4 text-3xl md:text-4xl font-heading font-bold text-foreground-900 leading-tight">
              Smart Spreadsheets<br />
              <span className="text-foreground-500 font-normal">For Every Haul</span>
            </h2>
            <div className="mt-8 space-y-4 text-sm text-foreground-600 leading-relaxed">
              <p>
                A <strong>pandabuyspreadsheet</strong> is a curated collection of verified product listings used by thousands of buyers worldwide to discover high-quality fashion, sneakers, and lifestyle products through international shopping agents. These spreadsheets save you countless hours of manual searching across forums and social media.
              </p>
              <p>
                Our team continuously updates the <strong>pandabuy spreadsheet</strong> database with fresh finds, removing dead links and adding new discoveries daily. Whether you are looking for the latest sneaker releases, trending streetwear pieces, or luxury accessories, the <strong>pandabuy finds spreadsheet</strong> has everything organized by category for effortless browsing.
              </p>
              <p>
                Unlike random forum posts or outdated social media threads, the <strong>best pandabuy spreadsheet 2026</strong> is regularly verified by our community. Each item includes quality scores, price ranges, and direct links so you can build the perfect <strong>pandabuy haul spreadsheet</strong> without the guesswork.
              </p>
            </div>
            <div className="mt-6">
              <Link
                to="/blog/pandabuy-spreadsheet-ultimate-guide-2026"
                className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer"
              >
                <span>Read the Complete Guide</span>
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </div>

          <div className="lg:w-3/5 relative">
            {/* 图片背后加大的装饰色块 */}
            <div className="absolute top-8 left-8 w-[70%] h-[80%] rounded-3xl bg-primary-100/40 pointer-events-none" />
            <div className="absolute -bottom-4 -right-4 w-[60%] h-[60%] rounded-3xl bg-accent-100/30 pointer-events-none" />
            <div className="flex gap-4 md:gap-6 items-start relative z-10">
              <div className="w-[45%]">
                <img
                  src="https://readdy.ai/api/search-image?query=Luxury%20designer%20sneakers%20close-up%20on%20warm%20cream%20concrete%20surface%20premium%20leather%20texture%20visible%20editorial%20product%20photography%20soft%20diffused%20natural%20lighting%20warm%20neutral%20earth%20tones%20elegant%20minimal%20composition%20high%20detail&width=600&height=750&seq=about-sneaker-v2-2026&orientation=portrait"
                  alt="Designer sneakers pandabuy spreadsheet find"
                  title="Verified pandabuy sneaker finds"
                  className="w-full rounded-2xl object-cover aspect-[4/5]"
                />
              </div>
              <div className="w-[55%] mt-12">
                <img
                  src="https://readdy.ai/api/search-image?query=Urban%20streetwear%20outfit%20ensemble%20displayed%20on%20wooden%20hanger%20against%20warm%20neutral%20wall%20trendy%20bomber%20jacket%20hoodie%20and%20cargo%20pants%20editorial%20fashion%20photography%20soft%20natural%20light%20warm%20earthy%20tones%20clean%20modern%20aesthetic&width=700&height=900&seq=about-outfit-v2-2026&orientation=portrait"
                  alt="Streetwear outfit pandabuy spreadsheet collection"
                  title="Pandabuy clothing spreadsheet finds"
                  className="w-full rounded-2xl object-cover aspect-[3/4]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}